import React from 'react';
import { fetchUtils, usePermissions } from 'react-admin';
const fetch = fetchUtils.fetchJson;

const BASE_URL = window.nobid_endpoint+'/alerts_status';

export class AlertComponent extends React.Component {
  state = {
    message: "",
    color: "#36ca11"
  };
  constructor(permissions, props) {
    super();
  }
  componentDidMount() {
    this.fetchData();
  }
  fetchData() {
    let url = BASE_URL;
    let options = {headers: new Headers()};
    options.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
//    options.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, options).then(({ headers, json }) => {
      if (json && json.length>0) {
    	  let alrt = json[0];
    	  this.setState({message: alrt.message});
    	  if (alrt.type==="ALERT") this.setState({color: "red"});
    	  else this.setState({color: "#36ca11"});
      }
    });
  }
  
  render() {
	if (this.state.message && this.state.message.length>0) {
	  return (
        <div style={{ fontFamily:'Roboto, Helvetica, Arial, sans-serif,', fontWeight:'bold', color:'white', 
        	fontSize:'medium', backgroundColor:this.state.color, marginTop:'15px', padding:'10px'}}>
          {this.state.message}
        </div>
      )
	} else {
		return (null)
	}
  }
}